<template>
  <div id="shirt">
    <svg
      ref="svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="10 0 500 500"
    />
  </div>
</template>
<script>
export default {
  name: "Shirt",
  props: ["primary_color", "type", "secondary_color", "number"],
  mounted() {
    this.draw();
  },
  watch: {
    primary_color: function() {
      this.draw();
    },
    type: function() {
      this.draw();
    },
    secondary_color: function() {
      this.draw();
    },
    number: function() {
      this.draw();
    }
  },
  methods: {
    draw() {
      // remove svg childs
      while (this.$refs.svg.firstChild) {
        this.$refs.svg.removeChild(this.$refs.svg.firstChild);
      }
      // create polygon element
      var polygon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "polygon"
      );
      polygon.setAttribute(
        "points",
        "357.344,49.996 326,51.332 280.672,105.996 256,109.996 226.672,106.668 182,45.996 11.664,123.004 47.664,235.004 112.328,217.668 119,457.668 389.656,457.668 393.656,214.332 464.328,241.668 500.328,131.668 "
      );
      // check if isset color
      polygon.setAttribute(
        "fill",
        this.primary_color && this.primary_color != ""
          ? this.primary_color
          : "#FFFFFF"
      );
      this.$refs.svg.appendChild(polygon);

      if (
        this.type != "" &&
        this.primary_color != this.secondary_color &&
        this.secondary_color != ""
      ) {
        switch (this.type) {
          case "vertical_stripes":
            this.drawPolygon(
              "155,64 184,64 155,448 184,448 155,64 155,448 184,64 184,448"
            );
            this.drawPolygon(
              "240,116 270,116 240,448 270,448 240,116 240,448 270,116 270,448"
            );
            this.drawPolygon(
              "357,64 328,64 357,448 328,448 357,64 357,448 328,64 328,448"
            );
            break;
          case "horizontal_stripes":
            this.drawPolygon(
              "485,138 475,167 27,138 37,167 485,138 27,138 475,167 37,167"
            );
            this.drawPolygon(
              "383,223 383,252 129,223 129,252 383,223 129,223 383,252 129,252"
            );
            this.drawPolygon(
              "383,308 383,337 129,308 129,337 383,308 129,308 383,337 129,337"
            );
            this.drawPolygon(
              "383,393 383,422 129,393 129,422 383,393 129,393 383,422 129,422"
            );
            break;
          case "diagonal_strip":
            this.drawPolygon(
              "358,64 384,80 128,448 160,448 358,64 128,448 384,80 160,448"
            );
            break;
          case "inverted_chevron":
            this.drawPolygon(
              "128,80 98,97 256,200 256,250 128,80 256,200 98,97 256,250"
            );
            this.drawPolygon(
              "384,80 414,97 256,200 256,250 384,80 256,200 414,97 256,250"
            );
            break;
          case "arlequine":
            this.drawPolygon(
              "135,64 200,64 135,270 200,270 135,64 135,270 200,64 200,270"
            );
            this.drawPolygon(
              "250,100 250,270 115,70 115,270 250,100 115,70 250,270 115,270"
            );
            this.drawPolygon(
              "400,270 400,450  250,450 250,270 400,270 250,450"
            );
            break;
        }
      }

      // create path
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute(
        "d",
        "M362.672,42.66h-53.328c0,29.414-23.938,53.336-53.344,53.336s-53.328-23.922-53.328-53.336h-53.336L0,127.996 l42.672,117.336l64-21.336V469.34h298.672V223.996l64,21.336L512,127.996L362.672,42.66z M456.375,218.527l-44.297-14.766 L384,194.395v29.602v224H128v-224v-29.602l-28.078,9.367l-44.297,14.766l-29.43-80.93L155,63.996h29.43 c9.18,30.844,37.75,53.336,71.57,53.336c33.828,0,62.391-22.492,71.562-53.336H357l128.812,73.602L456.375,218.527z"
      );
      this.$refs.svg.appendChild(path);
    },
    drawPolygon(points) {
      var polygon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "polygon"
      );
      polygon.setAttribute("points", points);
      polygon.setAttribute(
        "fill",
        this.secondary_color && this.secondary_color != ""
          ? this.secondary_color
          : "#FFFFFF"
      );
      polygon.setAttribute(
        "stroke",
        this.secondary_color && this.secondary_color != ""
          ? this.secondary_color
          : "#FFFFFF"
      );
      this.$refs.svg.appendChild(polygon);
    }
  }
};
</script>
<style lang="scss" scoped>
#shirt {
  text-align: center;
  overflow: hidden;
  height: 95px;
}
svg {
  height: 100px;
  width: 100px;
}
</style>
